module.exports = __webpack_public_path__ + "static/media/events.ef9c041b.svg";